import _ from 'underscore';

import {omitNull} from 'common/utils';


export default class AgencyUser {
  /* eslint-disable camelcase */
  constructor({
    username,
    email,
    first_name,
    last_name,
    phone,
    roles,
  }) {
    this.username = username || null;
    this.email = email || null;
    this.first_name = first_name || null;
    this.last_name = last_name || null;
    this.phone = phone || null;
    this.roles = roles || [];
  }
  /* eslint-enable camelcase */

  get id() {
    return this.username;
  }

  clone() {
    return new AgencyUser(this.serialize());
  }

  get rolesString() {
    const roles = _.map(this.roles, (role) =>
      `${role.role.charAt(0).toUpperCase()}${role.role.slice(1)}`);
    return roles.join(', ');
  }

  /* Combine this user's first and last names. */
  get fullName() {
    if (this.first_name && this.last_name) {
      return `${this.first_name} ${this.last_name}`;
    }
    return this.first_name || this.last_name || '';
  }

  /* Include the user's username, if available. */
  get name() {
    const name = this.fullName;
    const username = this.username || '';
    if (name && username) {
      return `${name} (${username})`;
    }
    return name || username || '';
  }

  isValid() {
    return _.all([
      this.username,
      this.email,
      this.first_name,
      this.last_name,
      this.phone && this.phone.replace(/\D/g, '').length === 10,
    ]);
  }

  serialize() {
    return omitNull({
      username: this.username,
      email: this.email,
      first_name: this.first_name,
      last_name: this.last_name,
      phone: this.phone,
      roles: this.roles.slice(),
    });
  }
}



// WEBPACK FOOTER //
// ./src/common/types/AgencyUser.js